export enum LoadState {
	NotLoaded = 0,
	InProgress = 1,
	Loaded = 2,
	Failed = 3,
	PENDING,
}

export enum SaveState {
	NotStarted = 0,
	Progress = 1,
	Saved = 2,
}

export enum USER_ROLES {
	ADMIN = 1,
	CSR = 2,
	PRODUCER = 3,
	MARKETER = 4,
	BRANCH_MANAGER = 5,
}

export enum TEMPLATE_RELATED_MODULE_ID {
	LEAD = "LEAD",
	G4SIGN = "G4SIGN",
	TASK = "TASK",
	LEADS_FROM_WEBSITE = "LEADS_FROM_WEBSITE",
	CROSSROADS_LEAD = "Crossroads Lead"
}

export enum TASK_SUBTYPE {
	VEHICLE_CHANGE = "Vehicle Change",
	DRIVER_CHANGE = "Driver Change",
	COVERAGE_CHANGE = "Coverage Change",
	GARAGE_PLATE_CHANGE = "Garage Plate Change",
	INTERESTED_PARTY_CHANGE = "Interested Party Change",
	LESSOR_CHANGE = "Lessor Change",
	ADDRESS_CHANGE = "Address Change",
	RISK_LOCATION_CHANGE = "Risk Location Change",
	CANCELLATION_REINSTALLMENT = "Cancellation/Reinstatement",
	BUSINESS_SUBMISSION = "Business Submission",
	GENERAL_CHANGE = "General Change",
	PAYMENT_AUTH_CHANGE = "Payment Authorization Change",
	LAO_BOR = "LOA/BOR",
	LETTER_OF_EXPERIENCE = "Letter of Experience",

	NEW_BUSINESS = "Business",
	NEW_PERSONAL_AUTO = "Personal Auto",
	NEW_HOME = "Home",
	NEW_COMMERCIAL_AUTO = "Commercial Auto",
	NEW_PERSONAL_AND_HOME = "Personal Auto & Home",
	REMARKET_COMMERCIAL_AUTO = "Commercial Auto",
	REMARKET_HOME = "Home",
	REMARKET_BUSINESS = "Business",
	REMARKET_PERSONAL_AUTO = "Personal Auto",
	REMARKET_PERSONAL_AND_HOME = "Personal Auto & Home",
	QUOTE_REQUEST = "Quote Request",
	TASK_CERTIFICATE_OF_INSURANCE = "Certificate of Insurance",
}

export enum POLICIES {
	BUSINESS_POLICY = "Business Policy",
	AUTOMOBILE_POLICY = "Automobile Policy",
	HABITATIONAL_POLICY = "Habitational Policy",
	COMMERCIAL_AUTO_POLICY = "Commercial Auto Policy",
	LIFE_AND_FINCANCIAL_POLICY = "Life & Financial Policy",
}

export enum POLICIES_NAMES {
	BUSINESS_POLICY = "Business",
	AUTOMOBILE_POLICY = "Automobile",
	HABITATIONAL_POLICY = "Habitational",
	COMMERCIAL_AUTO_POLICY = "Commercial Auto",
	LIFE_AND_FINCANCIAL_POLICY = "Life & Financial",
}

export enum ERROR_MESSAGES {
	"NO_RECORD_FOUND" = "Unfortunately, there are no records available at the moment.",
	"SERVER_ERROR" = "Someting went to be wrong!",
	"POLICY_NOT_FOUND" = "Oops! We couldn't find any records at the moment. Please ensure that the provided information is accurate and try again.",
}

export enum MODULE_IDS {
	TASK = "latest_tasks",
	LEADS = "latest_leads",
	OPPORTUNITY = "latest_opportunity",
	CUSTOMER = "latest_customer_personal_information",
	USER = "latest_user",
	ROLE = "change_role",
	SECURITY = "role_module",
	BRANCH = "latest_branch",
	ZONE = "zone",
	EVENTS = "latest_events",
	ONLINE_DSA_LIMIT = "latest_online_dsa_limit",
	LEADS_FROM_WEBSITE = "latest_helping_leads",
	CROSSROADS_LEAD = "Crossroads Lead"
}

export enum TRANSACTION_TYPE_ENUM {
	AuditPlus = "+ Audit",
	AuditMinus = "- Audit",
	Tax = "Tax",
	Reinstate = "Reinstate",
	Reissue = "Reissue",
	Rewrite = "Re-write",
	Correction = "Correction",
	Cancellation = "Cancellation",
	EndorsementPlus = "+ Endorsement",
	EndorsementMinus = "- Endorsement",
	Renewal = "Renewal",
	New = "New",
	FeeNSFFee = "Fee - NSF Fee",
	FeeServiceFee = "Fee - Service Fee",
	FeeInsuranceReports = "Fee - Insurance Reports",
	FeeFacilityFee = "Fee - Facility Fee",
	FeeMGAInsurerFee = "Fee - MGA/Insurer Fee",
	Payment = "Payment",
}

export enum MODULE_NAMES {
	LEADS = "Leads",
	OPPORTUNITY = "Opportunity",
	CUSTOMER = "Customers",
	POLICIES = "Policies",
	LEGALS = "Legals",
	USER = "Users",
	ROLE = "Roles",
	SECURITY = "Security",
	EVENTS = "Events",
	ONLINE_DSA_LIMIT = "Online DSA Limit",
	LEADS_FROM_WEBSITE = "Helpline Leads",
	CROSSROADS_LEAD = "Crossroads Leads"
}

export enum ALLOWED_MODULES {
	SECURITY = "SECURITY|SECURITY|ROLE_MODULE",
	ROLE_GROUPS = "SECURITY|ROLE GROUPS|LATEST_ROLE_GROUPS",
	LEADS = "LEAD|B2B LEAD|LATEST_LEADS",
	CAMPAIGN_LEAD="LEAD|CAMPAIGN LEAD|LATEST_CROSSROADS_LEAD",
	CAMPAIGN="CAMPAIGN|CAMPAIGN|LATEST_CAMPAIGN",
	RSA_PACKAGES = "CAMPAIGN|RSA PACKAGES|LATEST_RSA_PACKAGE_MASTER",
	PROMOCODE = "CAMPAIGN|PROMOCODE|LATEST_RSA_PROMOCODE",
	DISPOSITION = "CAMPAIGN|DISPOSITION|LATEST_DISPOSITION",
	APIKEYS = "CAMPAIGN|API KEYS|LATEST_APIKEY",
	ONLINE_DSA_LIMIT = "ONLINE_DSA_LIMIT|ONLINE_DSA_LIMIT|LATEST_ONLINE_DSA_LIMIT",
	OPPORTUNITY = "OPPORTUNITY|OPPORTUNITY|LATEST_OPPORTUNITY",
	CUSTOMER = "CUSTOMER|CUSTOMER|CUSTOMER_FACT",
	TEMPLATES = "TEMPLATE|TEMPLATE|LATEST_TEMPLATES",
	USERS = "USERS|USERS|LATEST_USER",
	ROLES = "latest_roles",
	MANAGE_SITE = "ADMIN_MANAGE SITE_LATEST_MANAGE_SITE",
	USER_BRANCH = "DATA MANAGEMENT|BRANCH|LATEST_BRANCH",
	ZONE = "DATA MANAGEMENT|ZONE|LATEST_ZONE",
	ENV = "SITE CONFIGURATION|MANAGE ENVIRONMENT CONFIGURATION|LATEST_ENVIRONMENT_CONFIGURATION",
	PARTNERS = "PARTNER|PARTNERS|LATEST_PARTNER_MASTER",
	BULK_ACTIVATION = "PARTNER|BULK ACTIVATIONS|LATEST_BULK_ACTIVATION", 
	PARTNERS_MEMBERSHIP = "PARTNER|PARTNER MEMBERSHIPS|LATEST_PARTNER_MEMBERSHIP",
	COMPLAINT_REPORT = "REPORTS|COMPLAINT REPORT|LATEST_COMPLAINT_LOG", 
	COMPLAINTS = "PARTNER|COMPLAINTS|LATEST_COMPLAINTS",
	PARTNER_PACKAGE_MASTER = "PARTNER|PARTNER PACKAGES|LATEST_PARTNER_PACKAGE_MASTER", 
	CALLING = "CALLING|CALLING|LATEST_CALLING_CAMPAIGNS",
	CALLING_DATA = "CALLING DATA|CALLING DATA|LATEST_CALLING_DATA_LIST",
	BULK_CALL_CAMPAIGN = "CALLING|BULK CALL CAMPAIGN|LATEST_BULK_CALL_CAMPAIGN",
	BULK_CALL_CAMPA_HIST = "CALLING|BULK CALL CAMPAIGN HISTORY|LATEST_BULK_CALL_CAMPAIGN_HISTORY",
	MARKETING = "MARKETING",
	EVENTS = "EVENTS|EVENTS|LATEST_EVENTS",
	CHATS = "CHATS",
	ORG_ENV_CONFIG = "ORG_ENV_CONFIG",
	CUSTOMER_CONNECTIONS = "CUSTOMER CONNECTIONS|CUSTOMER CONNECTIONS|LATEST_USER_DETAILS",
	MANAGE_MEMBERSHIP = "MANAGE_MEMBERSHIP|MANAGE_MEMBERSHIP|MANAGE_MEMBERSHIP",
	LAWYERED = "PARTNER|LAWYERED|LATEST_LAWYERED",
	LAWYERED_CHALLAN = "PARTNER|LAWYERED CHALLAN|LATEST_LAWYERED_CHALLAN",
}
